(function($, window) {
    $.layoutManagerHandlers.registerCardHandler({
        'fr.uca.layout.card.bean.CarteALaUneCardBean': {
            beforeEditOpen: function () {
                CKEDITOR_HELPER.beforeDomMove('carte_a_la_une_toolbox');
            },
            onEditActive: function () {
                CKEDITOR_HELPER.afterDomMove('carte_a_la_une_toolbox');
            },
            check: function (card) {
                if (card && card.model && card.model.affichebloc) {
                    return $.layoutManager.states.checked;
                }
                return $.layoutManager.states.incomplete;
            },
            edit: function (card, editCallback) {
                editCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
            },
            save: function (card, saveCallback) {
                saveCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
            },
            onEditClose: function () {
            },
            updateView: function (card, view) {
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.title, card.model.affichebloc, view);
            }
        },
        'fr.uca.layout.card.bean.CarteActualiteEtFocusCardBean': {
            beforeEditOpen: function () {
            },
            onEditActive: function () {
            },
            check: function (card) {
                if (card && card.model && card.model.affichebloc) {
                    return $.layoutManager.states.checked;
                }
                return $.layoutManager.states.incomplete;
            },
            edit: function (card, editCallback) {
                editCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                LienFields.bind(this.$activeEditPanel, 'lien', card.model.lien);
            },
            save: function (card, saveCallback) {
                saveCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                card.model.lien = LienFields.unbind(this.$activeEditPanel, 'lien');
            },
            onEditClose: function () {
            },
            updateView: function (card, view) {
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.title, card.model.affichebloc, view);
            }
        },
        'fr.uca.layout.card.bean.RechercherFormationSimpleCardBean': {
            beforeEditOpen: function () {
            },
            onEditActive: function () {
            },
            check: function (card) {
                if (card && card.model && card.model.affichebloc) {
                    return $.layoutManager.states.checked;
                }
                return $.layoutManager.states.incomplete;
            },
            edit: function (card, editCallback) {
                editCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
            },
            save: function (card, saveCallback) {
                saveCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
            },
            onEditClose: function () {
            },
            updateView: function (card, view) {
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.title, card.model.affichebloc, view);
            }
        },
        'fr.uca.layout.card.bean.UcaCestAussiCardBean': {
            check: function (card) {
                if (card && card.model && card.model.affichebloc) {
                    return $.layoutManager.states.checked;
                }
                return $.layoutManager.states.incomplete;
            },
            edit: function (card, editCallback) {
                editCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                this.vm_item = RepeaterFields.bind(this.$activeEditPanel, 'item', card.model.item);
            },
            save: function (card, saveCallback) {
                saveCallback();
                // this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                card.model.item = RepeaterFields.unbind(this.$activeEditPanel, 'item', this.vm_item);
                this.vm = null;
            },
            onEditClose: function () {
                if (this.vm_item != null) {
                    RepeaterFields.unbind(this.$activeEditPanel, 'item', this.vm_item);
                    this.vm_item = null;
                }
            },
            updateView: function (card, view) {
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.title, card.model.affichebloc, view);
            }
        },
        'fr.uca.layout.card.bean.ToolboxDesign2021CardBean': {
            beforeEditOpen: function () {
                CKEDITOR_HELPER.beforeDomMove('toolbox_design2021_toolbox');
            },
            onEditActive: function () {
                CKEDITOR_HELPER.afterDomMove('toolbox_design2021_toolbox');
            },
            check: function (card) {
                if (card && card.model && card.model.affichebloc) {
                    return $.layoutManager.states.checked;
                }
                return $.layoutManager.states.incomplete;
            },
            edit: function (card, editCallback) {
                editCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
            },
            save: function (card, saveCallback) {
                saveCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
            },
            onEditClose: function () {
            },
            updateView: function (card, view) {
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.title, card.model.affichebloc, view);
            }
        },
        "fr.uca.layout.card.bean.MoteurDeRecherche2023CardBean": {
            check: function (card) {
                if (card) {
                    return $.layoutManager.states.checked;
                }
                return $.layoutManager.states.incomplete;
            },
            edit: function (card, editCallback) {
                editCallback();
                this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                this.vm = RepeaterFields.bind(this.$activeEditPanel, 'tags', card.model.tags);
            },
            save: function (card, saveCallback) {
                saveCallback();
                card.model.tags = RepeaterFields.unbind(this.$activeEditPanel, 'tags', this.vm);
                this.vm = null;
            },
            onEditClose: function () {
                if (this.vm != null) {
                    RepeaterFields.unbind(this.$activeEditPanel, 'tags', this.vm);
                    this.vm = null;
                }
            }
        }
    });
})(jQuery.noConflict(), window);
